import React from 'react';
import "./Modal.scss";

function handleModal(content, setModal) {
    return <div className="elevert-modal" onClick={() => setModal(undefined)}>
        <div className="elevert-modal-background"></div>
        <div className="elevert-modal-content"><img src={content.src} alt={content.alt} /></div>
    </div>
}
export default handleModal;